export const LOADER = {
  loadMore: 'Load More',
  loading: 'Loading...',
};



// WEBPACK FOOTER //
// ./app/javascript/constants/copy.js